var map = {
	"./bg-exclusive.webp": 1407,
	"./border-bg-sm.png": 1408,
	"./border-bg-xm.png": 1409,
	"./border-bg.png": 1410,
	"./btn-active.png": 1411,
	"./casino-hover.webp": 1412,
	"./cny-flower-1.webp": 1413,
	"./cny-flower-2.webp": 1414,
	"./cny-mobile-bg.webp": 1415,
	"./content-deco-1.webp": 1416,
	"./content-deco-2.webp": 1417,
	"./content-deco-3.webp": 1418,
	"./content-deco-4.webp": 1419,
	"./content-deco-5.webp": 1420,
	"./deposit-icon.webp": 1421,
	"./event-border-hover.webp": 1422,
	"./games-hover.webp": 1423,
	"./home-icon-active.webp": 1424,
	"./home-icon.webp": 1425,
	"./live-icon-active.webp": 1426,
	"./live-icon.webp": 1427,
	"./lottery-hover.webp": 1428,
	"./master-bg.png": 1429,
	"./me-icon-active.webp": 1430,
	"./me-icon.webp": 1431,
	"./p2p-hover.webp": 1432,
	"./platform.webp": 1433,
	"./product-overview-bg.webp": 1434,
	"./promos-icon-active.webp": 1435,
	"./promos-icon.webp": 1436,
	"./slots-hover.webp": 1437,
	"./sponsor-icon-active.webp": 1438,
	"./sponsor-icon.webp": 1439,
	"./sports-hover.webp": 1440,
	"./title-deco-bg.webp": 1441,
	"./title-deco-left.webp": 1442,
	"./title-deco-right.webp": 1443,
	"./vip-icon-active.webp": 1444,
	"./vip-icon.webp": 1445,
	"./withdraw-icon.webp": 1446,
	"./wwr-bg.webp": 1447,
	"./wwr-img.webp": 1448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;